import PropTypes from 'prop-types';
import React from 'react';
import './style.css';

export const Pagination = ({
    currentPage,
    lastPage,
    pageSize,
    totalResults,
    handlePageChange,
    handlePageSize,
}) => {
    const pages = [];
    const startPage = Math.max(2, currentPage - 2); // Start from the second page
    const endPage = Math.min(lastPage - 1, currentPage + 2); // End at the second-to-last page

    // Add the first page button
    pages.push(
        <div
            className={currentPage === 1 ? 'pagination-2' : 'pagination-3'}
            key={1}
            onClick={() => handlePageChange(1)}
        >
            <div className={`element-2 ${currentPage === 1 ? 'element' : ''}`}>
                1
            </div>
        </div>,
    );

    // Add ellipsis if needed
    if (startPage > 2) {
        pages.push(
            <div className="pagination-3" key="start-ellipsis">
                <span className="page-ellipsis">...</span>
            </div>,
        );
    }

    // Add middle pages (use `i` here)
    for (let i = startPage; i <= endPage; i++) {
        pages.push(
            <div
                className={i === currentPage ? 'pagination-2' : 'pagination-3'}
                key={i}
                onClick={() => handlePageChange(i)}
            >
                <div
                    className={`element-2 ${i === currentPage ? 'element' : ''}`}
                >
                    {i}
                </div>
            </div>,
        );
    }

    // Add ellipsis before the last page if needed
    if (endPage < lastPage - 1) {
        pages.push(
            <div className="pagination-3" key="end-ellipsis">
                <span className="page-ellipsis">...</span>
            </div>,
        );
    }

    // Add the last page button
    if (lastPage > 1) {
        pages.push(
            <div
                className={
                    currentPage === lastPage ? 'pagination-2' : 'pagination-3'
                }
                key={lastPage}
                onClick={() =>
                    currentPage !== lastPage && handlePageChange(lastPage)
                }
            >
                <div
                    className={`element-2 ${currentPage === lastPage ? 'element' : ''}`}
                >
                    {lastPage}
                </div>
            </div>,
        );
    }

    return (
        <div className="frame-23">
            <div
                className={
                    'pagination-4 ' +
                    (currentPage === lastPage ? 'disabled-button' : '')
                }
                onClick={() => handlePageChange(currentPage - 1)}
            >
                <div
                    className={`element-2 ${currentPage === 1 ? 'disabled-text' : ''}`}
                >
                    Vorherige
                </div>
            </div>
            {pages}
            <div
                className={
                    'pagination-4 ' +
                    (currentPage === lastPage ? 'disabled-button' : '')
                }
                onClick={() => handlePageChange(currentPage + 1)}
            >
                <div
                    className={`element-2 ${currentPage === lastPage ? 'disabled-text' : ''}`}
                >
                    Nächste
                </div>
            </div>
            {/*
            <select className="pagination-controls" onChange={(e) => handlePageSize(e)} value={pageSize}>
                <option value={9}>9</option>
                <option value={18}>18</option>
                <option value={32}>32</option>
            </select>
            <div style={{ margin: "10px 0" }}>
                {totalResults} Ergebnisse gefunden
            </div>
			*/}
        </div>
    );
};

Pagination.propTypes = {
    currentPage: PropTypes.number.isRequired,
    lastPage: PropTypes.number.isRequired,
    pageSize: PropTypes.number.isRequired,
    totalResults: PropTypes.number.isRequired,
    handlePageChange: PropTypes.func.isRequired,
    handlePageSize: PropTypes.func.isRequired,
};
